// ** Initial State
const initialState = {
    filterStatus: null
  }
  
  const driverStatusReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_DRIVER_FILTER_STATUS':
        return {
          ...state,
          filterStatus: action.payload
        }
      
      default:
        return state
    }
  }
  
  export default driverStatusReducer